import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Filter, Download, Info } from 'lucide-react';
export function Reports() {
  return <div className="space-y-8" data-id="element-262">
      <div className="flex items-center justify-between" data-id="element-263">
        <div data-id="element-264">
          <h1 className="text-2xl font-bold text-stone-900" data-id="element-265">
            Insights & Reports
          </h1>
          <p className="text-stone-500 mt-1" data-id="element-266">
            Analyze the relationship between attendance and literacy.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-267">
          <Button variant="outline" icon={<Download size={16} data-id="element-269" />} data-id="element-268">
            Export Data
          </Button>
          <Button icon={<Filter size={16} data-id="element-271" />} data-id="element-270">Filter View</Button>
        </div>
      </div>

      {/* Key Insights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-272">
        <Card className="bg-gradient-to-br from-teal-50 to-white border-teal-100" data-id="element-273">
          <h3 className="text-teal-900 font-semibold mb-2" data-id="element-274">
            Attendance Impact
          </h3>
          <div className="text-3xl font-bold text-teal-700 mb-2" data-id="element-275">2.3x</div>
          <p className="text-sm text-teal-800" data-id="element-276">
            Students with chronic absence are 2.3x more likely to need literacy
            support.
          </p>
        </Card>
        <Card data-id="element-277">
          <h3 className="text-stone-900 font-semibold mb-2" data-id="element-278">
            Grade Level Trend
          </h3>
          <div className="text-3xl font-bold text-stone-900 mb-2" data-id="element-279">+12%</div>
          <p className="text-sm text-stone-600" data-id="element-280">
            Increase in 3rd grade proficiency compared to Fall 2023.
          </p>
        </Card>
        <Card data-id="element-281">
          <h3 className="text-stone-900 font-semibold mb-2" data-id="element-282">
            Intervention Efficacy
          </h3>
          <div className="text-3xl font-bold text-stone-900 mb-2" data-id="element-283">85%</div>
          <p className="text-sm text-stone-600" data-id="element-284">
            Of students in "Reading Group B" showed improvement this quarter.
          </p>
        </Card>
      </div>

      {/* Main Chart Placeholder */}
      <Card className="min-h-[400px] flex flex-col" data-id="element-285">
        <div className="flex justify-between items-center mb-8" data-id="element-286">
          <h3 className="font-semibold text-stone-900" data-id="element-287">
            Literacy vs. Attendance Correlation
          </h3>
          <div className="flex gap-2" data-id="element-288">
            <span className="flex items-center gap-1 text-xs text-stone-500" data-id="element-289">
              <span className="w-3 h-3 rounded-full bg-teal-500" data-id="element-290"></span> On
              Track
            </span>
            <span className="flex items-center gap-1 text-xs text-stone-500" data-id="element-291">
              <span className="w-3 h-3 rounded-full bg-amber-400" data-id="element-292"></span>{' '}
              Approaching
            </span>
            <span className="flex items-center gap-1 text-xs text-stone-500" data-id="element-293">
              <span className="w-3 h-3 rounded-full bg-coral-500" data-id="element-294"></span> Needs
              Support
            </span>
          </div>
        </div>

        {/* Scatter Plot Visualization (CSS only for prototype) */}
        <div className="flex-1 relative border-l border-b border-stone-200 m-4" data-id="element-295">
          {/* Labels */}
          <div className="absolute -left-12 top-1/2 -rotate-90 text-xs text-stone-400 font-medium" data-id="element-296">
            Literacy Score
          </div>
          <div className="absolute bottom-[-2rem] left-1/2 text-xs text-stone-400 font-medium" data-id="element-297">
            Attendance Rate (%)
          </div>

          {/* Grid Lines */}
          <div className="absolute inset-0 grid grid-cols-4 grid-rows-4" data-id="element-298">
            {[...Array(4)].map((_, i) => <div key={i} className="border-t border-stone-100 w-full h-full" data-id="element-299"></div>)}
          </div>

          {/* Data Points (Mock Scatter) */}
          {[...Array(40)].map((_, i) => {
          const attendance = 70 + Math.random() * 30; // 70-100%
          // Correlation: higher attendance -> higher score generally
          const scoreBase = (attendance - 70) * 20;
          const score = scoreBase + Math.random() * 400 + 200;
          let color = 'bg-coral-500';
          if (score > 600) color = 'bg-teal-500';else if (score > 450) color = 'bg-amber-400';
          return <div key={i} className={`absolute w-3 h-3 rounded-full ${color} opacity-70 hover:opacity-100 hover:scale-125 transition-all cursor-pointer shadow-sm`} style={{
            left: `${(attendance - 70) * 3.33}%`,
            bottom: `${score / 1000 * 100}%`
          }} title={`Attendance: ${Math.round(attendance)}%, Score: ${Math.round(score)}`} data-id="element-300"></div>;
        })}
        </div>
      </Card>
    </div>;
}